<template>
	<el-col>
		<!-- <right-back style="margin-top:5px;"/> -->
		<div style="display:flex;justify-content: flex-end;margin-right: 10px;margin-bottom: 10px;"></div>
			<el-row>
				<el-form :inline="true" :model="addNewSourceForm" :label-width="isMobile?'70px':'100px'" style="margin-top:-2rem;" label-position="left">
					<el-descriptions class="margin-top" :label-style="labelStyle" title="" size="mini" :column="isMobile?1:2" border>
						<template slot="extra">
							<div style="display:flex;margin-top:-3rem;">
								<el-button @click="onGoback" type="danger">返回</el-button>
							</div>
						</template>
						<el-descriptions-item>
							<template slot="label">
								通话编号
							</template>
							<el-input  placeholder="请输入通话编号" v-model="addNewSourceForm.sessionCode" @input="changeSCCode"></el-input>
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								工单编号
							</template>
							<el-input  placeholder="请输入工单编号" v-model="addNewSourceForm.sheetCode"></el-input>
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								工单类型
							</template>
							<el-cascader
								placeholder="请选择工单类型"
                                :options="typeList"
                                :props="props"
                                v-model="addNewSourceForm.sheetTypeIds"
                                clearable></el-cascader>
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								紧急程度
							</template>
							<el-select placeholder="请选择紧急程度" v-model="addNewSourceForm.alertLevel" clearable >
								<el-option
									v-for="item in gradeList"
									:key="item.value"
									:label="item.label"
									:value="item.value">
								</el-option>
							</el-select>
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								公司类型
							</template>
							<el-select placeholder="请选择公司类型" v-model="addNewSourceForm.companyType" clearable @change="onCompanyChange">
								<el-option
									v-for="item in companyTypeList"
									:key="item.value"
									:label="item.label"
									:value="item.value">
								</el-option>
							</el-select>
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								公司名称
							</template>
							<el-input placeholder="请输入公司名称" v-model="addNewSourceForm.companyName" @change="onCompanyChange"></el-input>
						</el-descriptions-item>
						<el-descriptions-item v-if="addNewSourceForm.companyType == '最终用户'">
							<template slot="label">
								经销商名称
							</template>
							<el-input placeholder="请输入经销商名称" v-model="addNewSourceForm.jxsName"></el-input>
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								联系人
							</template>
							<el-input  placeholder="请输入联系人" v-model="addNewSourceForm.contactUser"></el-input>
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								联系电话
							</template>
							<el-input  placeholder="请输入联系电话" v-model="addNewSourceForm.tel" @input="changeTel"></el-input>
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								邮箱
							</template>
							<el-input  placeholder="请输入邮箱" v-model="addNewSourceForm.email"></el-input>
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								地址
							</template>
							<el-input  placeholder="请输入地址" v-model="addNewSourceForm.address"></el-input>
						</el-descriptions-item>
						<el-descriptions-item :span="addNewSourceForm.companyType !== '最终用户'?'2':'1'">
							<template slot="label">
								网域名称
							</template>
							<el-input  placeholder="请输入网域名称" v-model="addNewSourceForm.account"></el-input>
							<el-row v-if="companyCnt>1">
								<div style="margin-left:300px;">
									<el-link :disabled="curNo==0" type="primary"  @click="clickNext(-1)">上一条</el-link>
									<el-link :disabled="curNo==companyCnt-1" type="primary"  @click="clickNext(1)">下一条</el-link>
								</div>
							</el-row>
						</el-descriptions-item>
						<el-descriptions-item :span="'2'">
							<template slot="label">
								工单主题
							</template>
							<el-input  placeholder="请输入工单主题" v-model="addNewSourceForm.title"></el-input>
						</el-descriptions-item>
						<el-descriptions-item :span="'2'">
							<template slot="label">
								工单内容
							</template>
							<el-input v-model="addNewSourceForm.content" size="medium" :rows="8" type="textarea"
								 autocomplete="off" placeholder="请输入工单内容" style="width:90%"
								></el-input>
						</el-descriptions-item>
						

						<!-- <div class="tableTitle"><span class="midText">工单处理</span></div> -->
						<el-descriptions-item :span="'2'">
							<template slot="label">
								处理人
							</template>
							<el-cascader
                                :options="groupUserList"
                                :props="props"
								filterable 
								placeholder="请选择处理人"
                                v-model="addNewSourceForm.toUIds"
                                clearable></el-cascader>
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								附件
							</template>
							<my-upload-file-form-item v-model="addNewSourceForm.sample" :multiple="true" label="" :limit="10" />
						</el-descriptions-item>
						<!-- <el-descriptions-item>
							<template slot="label">
								工单状态
							</template>
							<el-select v-model="addNewSourceForm.status" clearable placeholder="请选择工单状态">
								<el-option
									v-for="item in statusList"
									:key="item.value"
									:label="item.label"
									:value="item.value">
								</el-option>
							</el-select>
						</el-descriptions-item>						 -->
					</el-descriptions>


						<div v-if="activities.length>0" class="tableTitle"><span class="midText">执行日志</span></div>
						
						<el-timeline class="rightfirst-bottom-right">
							<el-timeline-item
								v-for="(activity, index) in activities"
								:key="index"
								:icon="activity.icon"
								:type="activity.type"
								:color="activity.color"
								:size="activity.size"
								:timestamp="activity.timestamp"
								placement="left"
							>
							<div class="rightfirst-bottom-right-left">
								<span>{{ activity.timestamp }}</span>
							</div>
							{{ activity.content }}
							</el-timeline-item>
						</el-timeline>


				</el-form>
			</el-row>
			<!-- <el-row v-if="!addNewSourceForm.id">
				<el-checkbox v-model="addNewSourceForm.sendMail">同时发送通知邮件&短信</el-checkbox>
			</el-row> -->
			<el-row type="flex" justify="center" style="margin-bottom: 20px;margin-top:1rem;">
				<el-button type="primary" @click="onConfirm">确定</el-button>
				<!-- <el-button v-if="addNewSourceForm.taskId" @click="onDelete" type="danger">删除</el-button> -->
				<!-- <common-back/> -->
				<div style="margin-left: 10px;"><el-button @click="onGoback" type="danger">返回</el-button></div>
			</el-row>
		</el-col>
</template>

<script>
import {mapGetters} from "vuex";
// import station from "@/views/Operate/Task/station";
// import {getDefaultStationXmlArray} from "@/views/Operate/Task/xml-manager";
import {getWorkSheetDetail,getCompanyInfo,getSheetCode,GetCompanyInfoByName} from "@/api/workSheet";
import {getToken} from "@/utils/auth";
import RightBack from "@/components/RightBack";
import CommonBack from "@/components/CommonBack";
import MyUploadFileFormItem from "@/components/MyUploadFileFormItem";
import { SendEmail } from '@/api/workSheet'


export default {
		name: "AddNewSourceDialog",
		components: {CommonBack,RightBack,MyUploadFileFormItem},//,todoItem,  SourcePrice
		computed: {...mapGetters(['groupUserList','typeList','gradeList','statusList',"isMobile"])},

		props: ['Id'],
		async mounted() {
			await this.$store.dispatch("workSheet/typeList", {userId:getToken()});
			await this.$store.dispatch("workSheet/gradeList",{userId:getToken()} );
			await this.$store.dispatch("workSheet/statusList", {userId:getToken()});
			await this.$store.dispatch('workSheet/groupUserList',{userId:getToken()});
			this.$store.dispatch("setting/checkDevice");
                // await this.$store.dispatch('operate/areaStationList');
                // await this.$store.dispatch('task/mediaTypeList');
				console.log('this.Id',this.Id)
				if (parseInt(this.Id)) {				
					const {data} = await getWorkSheetDetail({userId: getToken(), Id: this.Id});
					this.addNewSourceForm = data;
                    // console.log('aa',this.addNewSourceForm);

				}	else{
					const {data} = await getSheetCode({userId: getToken()});
					console.log('bb',data)
					this.addNewSourceForm.sheetCode = data[0].code;
				}			
		},

		data() {
				return {
					inputValue:'',
					list:[],
					tempCheckedArray:[],

					addNewSourceForm: {
						id:'',
						sessionCode: '',
						sheetCode: '',
						sheetTypeIds:[],
						title: '',                        
						content:'',
                        toUIds:[],
						ccUIds:[],
						flowtype:'1',
						alertLevel:'',
						itemContent:'',
						status:9,
						
						companyType:'',
						companyName:'',
						jxsName:'',
						contactUser:'',
						tel:'',
						address:'',
						email:'',
						account:'',
						sendMail:false,
						// stationXml: getDefaultStationXmlArray(),
					},
					activities:[],
                    props: { multiple: true },

					companyCnt:0,
					curNo:0,
					companyList:[],

					companyTypeList:[{label:'',value:''},{label:'经销商',value:'经销商'},{label:'最终用户',value:'最终用户'}],

					labelStyle: {
							'color': '#000',
							'text-align': 'center',
							'font-weight': '600',
							'height': '40px',
							// 'background-color': 'rgba(255, 97, 2, 0.1)',
							// 'min-width': '110px',
							// 'max-width': '150px',
							'width': '110px',
							'word-break': 'keep-all'
						}
				};
		},
		async beforeCreate() {
				// await this.$store.dispatch('source/getCityList');
				
                // this.$store.dispatch('products/promotionTypeList');
				// this.$store.dispatch('products/statusTypeList');
		},
		methods: {
			clickNext(val){
				this.curNo=this.curNo+val;
				// console.log('this.curNo',this.curNo)
				this.setCompany();
			},

			async onCompanyChange(){
				var that = this
				const {companyType,companyName} =this.addNewSourceForm
				if (companyType==='最终用户' && companyName.trim()!==''){
					if (this.addNewSourceForm.jxsName.trim()==='' || this.addNewSourceForm.address.trim()==='' || this.addNewSourceForm.account.trim()===''){
						await GetCompanyInfoByName({userId: getToken(),companyName}).then((res)=>{
							
							var data = res.data
							// console.log(data,data.length)
							if (data.length>0){
								if (that.addNewSourceForm.address.trim()==='' && data[0].address){
									that.addNewSourceForm.address = data[0].address
									// console.log('11',that.addNewSourceForm.address)
								}
								if (that.addNewSourceForm.account.trim()==='' && data[0].account){
									// console.log('2',that.addNewSourceForm.account.trim(),data[0].account)
									that.addNewSourceForm.account = data[0].account
									// console.log('22',that.addNewSourceForm.account.trim())

								}
								if (that.addNewSourceForm.jxsName.trim()==='' && data[0].jxsName){
									// console.log('2',that.addNewSourceForm.account.trim(),data[0].account)
									that.addNewSourceForm.jxsName = data[0].jxsName
									// console.log('22',that.addNewSourceForm.account.trim())

								}
								that.$forceUpdate()
							}
						})
					}
				}
			},

			setCompany(){
				this.addNewSourceForm.companyType=this.companyList[this.curNo].companyType;
				this.addNewSourceForm.companyName=this.companyList[this.curNo].companyName;
				this.addNewSourceForm.jxsName=this.companyList[this.curNo].jxsName;
				this.addNewSourceForm.contactUser=this.companyList[this.curNo].contactUser;
				this.addNewSourceForm.tel=this.companyList[this.curNo].tel;
				this.addNewSourceForm.address=this.companyList[this.curNo].address;
				this.addNewSourceForm.email=this.companyList[this.curNo].email;
				this.addNewSourceForm.account=this.companyList[this.curNo].account;
			},
			onGoback(){
                this.$emit('onclose',false)
            },

			async changeSCCode(){
				if (this.addNewSourceForm.sessionCode.length>0){
					const {data} = await getCompanyInfo({userId: getToken(), sessionCode: this.addNewSourceForm.sessionCode});
					// console.log('data',data,data?.length)
					this.companyCnt=data.length
					this.companyList = data;
					if (this.companyCnt>0){
						// console.log('1')
						this.curNo = 0
						this.setCompany();
					}else{
						console.log('0')
						// this.companyType='';
						// this.companyName='';
						// this.contactUser='';
						// this.tel='';
						// this.address='';
						// this.email='';
					}
				}else{
					console.log('kong')
					// this.phone='';
					// this.cName='';
					// this.cCompany='';
					// this.cAddress='';
				}
			},

			async changeTel(){
				var tel = this.addNewSourceForm.tel
				tel = tel.replace('-','').replace(' ','')
				if ((tel.length == 11 || tel.length == 12) && this.addNewSourceForm.contactUser == ''){
					const {data} = await getCompanyInfo({userId: getToken(), sessionCode: tel});
					this.companyCnt=data.length
					this.companyList = data;
					if (this.companyCnt>0){
						this.curNo = 0
						this.setCompany();
					}else{
						console.log('0')

					}
				}
			},

			 handleSubmit(){
				this.list.push(this.inputValue)
				this.inputValue=''

			},

			//点击ul下的li,删除对应的项,通过index标识
			handleDelete(index){
				this.list.splice(index,1)
			},

			async onConfirm() {
					// console.log('this.addNewSourceForm',this.addNewSourceForm);
					// return;
					const {
							sessionCode,sheetCode,sheetTypeIds,title,toUIds, alertLevel,status,content
						} = this.addNewSourceForm;
					if (!sessionCode?.trim()) {
						this.$message.warning('请输入通话编号')
						return;
      				}
					if (!sheetCode?.trim()) {
						this.$message.warning('请输入工单编号')
						return;
      				}
					if (!sheetTypeIds?.length ) {
						this.$message.warning('请选择工单类型')
						return;
					}
					console.log('alertLevel',alertLevel)
					if (!alertLevel ) {
						this.$message.warning('请选择紧急程度')
						return;
					}
					if (!title?.trim()) {
						this.$message.warning('请输入工单主题')
						return;
      				}
					  if (!content?.trim()) {
						this.$message.warning('请输入工单内容')
						return;
      				}
					
					
					if (!toUIds?.length ) {
						this.$message.warning('请选择处理人')
						return;
					}
					if (!status ) {
						this.$message.warning('请选择工单状态')
						return;
					}

					await this.$store.dispatch('workSheet/SaveWorkSheet', {form: this.addNewSourceForm}).then(()=>{
						// if (this.addNewSourceForm.sendMail){
						// 	SendEmail({userId: getToken(),id:})
						// }
						this.$message.success('编辑成功');
						// this.$router.go(-1);
						this.$emit('onclose',true)
					})

				},

				beforeClose() {
						// this.$emit('update:visible', false);
						this.$emit('onclose',false)
				},


				change(data){

				},
		}
}
</script>

<style scoped>
.el-form-item{
	margin-bottom: 5px;
}

.remark >>> .el-form-item__content{
  width:100%;
}
.tableTitle {
    position: relative;
    margin: 30px auto;
    width: 90%;
    height: 2px;
    background-color: #d4d4d4;
    text-align: center;
    font-size: 16px;
    color: rgba(101, 101, 101, 1);
  }
 .midText {
    position: absolute;
    left: 50%;
    background-color: #ffffff;
    padding: 0 15px;
    transform: translateX(-50%) translateY(-50%);
  }

	.companyRow{
	  /* height:40px; */
  } 
  
  /deep/ .el-descriptions--medium.is-bordered .el-descriptions-item__cell {
    padding: 0px;
}

</style>